module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="btn-group" id="stockroomTabs">\n    <button type="button" class="btn btn-default btn-sm stockroomTab" id = "solutions"><img class = "' +
((__t = (styles.stockroomTabIcon)) == null ? '' : __t) +
'" src = "';
 print(domain+'styles/icons/solutions.svg');
__p += '" id = "solutions"><br>' +
((__t = (terms.solutions[language])) == null ? '' : __t) +
'</button>\n    <button type="button" class="btn btn-default btn-sm stockroomTab" id = "glassware"><img class = "' +
((__t = (styles.stockroomTabIcon)) == null ? '' : __t) +
'" src = "';
 print(domain+'styles/icons/glassware.svg');
__p += '" id = "glassware"><br>' +
((__t = (terms.glassware[language])) == null ? '' : __t) +
'</button>\n    <button type="button" class="btn btn-default btn-sm stockroomTab" id = "tools"><img class = "' +
((__t = (styles.stockroomTabIcon)) == null ? '' : __t) +
'" src = "';
 print(domain+'styles/icons/tools.svg');
__p += '" id = "tools"><br>' +
((__t = (terms.tools[language])) == null ? '' : __t) +
'</button>\n</div>\n<div class="' +
((__t = ( styles.stockroomBody )) == null ? '' : __t) +
'">\n';
 if (drawer === "solutions"){ ;
__p += '\n	';
 for (var i = 0; i < solutions.length; i++){ ;
__p += '\n        ';
 var categoryIndex = i;;
__p += '\n        ';
 if (solutions[categoryIndex].SOLUTION) { ;
__p += '\n            ';
 for (var j = 0; j < solutions[categoryIndex].SOLUTION.length; j++) { ;
__p += '\n                ';
 var solutionIndex = j;;
__p += '\n                <div class = "solutionPreview addSolution" id = ' +
((__t = ( categoryIndex+","+solutionIndex )) == null ? '' : __t) +
' style = "cursor:pointer">\n                    ';
 var solution = solutions[categoryIndex].SOLUTION[solutionIndex]; ;
__p += '\n                    ';
 if (solution.vessel) { ;
__p += '\n                        <img class = "' +
((__t = (styles.stockroomIcon)) == null ? '' : __t) +
'" src = ' +
((__t = ( domain + vessels[solution.vessel].icon )) == null ? '' : __t) +
'>\n                    ';
 } else { ;
__p += '\n                        <img class = "' +
((__t = (styles.stockroomIcon)) == null ? '' : __t) +
'" src = "';
 print(domain+'styles/icons/250mLFlask.svg') ;
__p += '">\n                    ';
 } ;
__p += '\n                                    <span class = "stockroomLabel">\n                                        <div class = "labelName">\n                                            ' +
((__t = ( solution.name )) == null ? '' : __t) +
'\n                                        </div>\n                                        <div class = "labelDescription">\n                                            ' +
((__t = ( solution.description )) == null ? '' : __t) +
'\n                                        </div>\n                                        <div class = "labelName">\n                                            ' +
((__t = ( solution.volume ? solution.volume + " L" : "" )) == null ? '' : __t) +
'\n                                        </div>\n                                    </span>\n                                    <span class = "addButton btn glyphicon glyphicon-plus">\n                                    </span>\n                </div>\n            ';
 } ;
__p += '\n        ';
 } ;
__p += '\n        ';
 if (solutions[categoryIndex].DIRECTORY) {;
__p += '\n            ';
 for (var j = 0; j < solutions[categoryIndex].DIRECTORY.length; j++) { ;
__p += '\n                ';
 var categoryIndex1 = j ;
__p += '\n                <div id = ' +
((__t = ( j )) == null ? '' : __t) +
' class = "branch collapsed">\n                <span class="glyphicon glyphicon-chevron-right"></span>\n                <span class = "groupLabel">\n                                    ' +
((__t = ( solutions[i].DIRECTORY[categoryIndex1].name )) == null ? '' : __t) +
'\n                    <span class = "solutionCount">\n                                        ' +
((__t = ( "("+solutions[categoryIndex].DIRECTORY[categoryIndex1].SOLUTION.length+")" )) == null ? '' : __t) +
'\n                                    </span>\n                            </span>\n                </div>\n                <div id = ' +
((__t = ( "branchContent"+j )) == null ? '' : __t) +
' style = "display:none;">\n                ';
 for (var k = 0; k < solutions[categoryIndex].DIRECTORY[categoryIndex1].SOLUTION.length; k++) { ;
__p += '\n                ';
 var solutionIndex = k; ;
__p += '\n                <div class = "solutionPreview addSolution" id = ' +
((__t = ( categoryIndex+","+categoryIndex1+","+solutionIndex )) == null ? '' : __t) +
' style = "cursor:pointer">\n                    ';
 var solution = solutions[categoryIndex].DIRECTORY[categoryIndex1].SOLUTION[solutionIndex]; ;
__p += '\n                    ';
 if (solution.vessel) { ;
__p += '\n                        <img class = "' +
((__t = (styles.stockroomIcon)) == null ? '' : __t) +
'" src = ' +
((__t = ( domain + vessels[solution.vessel].icon )) == null ? '' : __t) +
'>\n                    ';
 } else { ;
__p += '\n                        <img class = "' +
((__t = (styles.stockroomIcon)) == null ? '' : __t) +
'" src = "';
 print(domain+'styles/icons/250mLFlask.svg');
__p += '">\n                    ';
 } ;
__p += '\n                                                            <span class = "stockroomLabel">\n                                                                <div class = "labelName">\n                                                                    ' +
((__t = ( solution.name )) == null ? '' : __t) +
'\n                                                                </div>\n                                                                <div class = "labelDescription">\n                                                                    ' +
((__t = ( solution.description )) == null ? '' : __t) +
'\n                                                                </div>\n                                                                <div class = "labelName">\n                                                                    ' +
((__t = ( solution.volume ? solution.volume + " L" : "" )) == null ? '' : __t) +
'\n                                                                </div>\n                                                            </span>\n                                                            <span class = "addButton btn glyphicon glyphicon-plus">\n                                                            </span>\n                </div>\n                ';
 } ;
__p += '\n                </div>\n            ';
 } ;
__p += '\n        ';
 } ;
__p += '\n    ';
 } ;
__p += '\n';
 } else if(drawer === "glassware"){ ;
__p += '\n';
console.log(glassware) ;
__p += '\n\n';
 var i = 0; ;
__p += '\n';
 for (var category in glassware){ ;
__p += '\n		';
 i= i+1; ;
__p += '\n      ';
 console.log(glassware[category]); ;
__p += '\n		';
 if (category === "Stand Alone"){ ;
__p += '\n			';
 for (vessel in  glassware[category]){ ;
__p += '\n				<div class = "glasswarePreview addGlassware" id = ' +
((__t = ( category+","+vessel )) == null ? '' : __t) +
' style = "cursor:pointer">\n					';
 var glass = glassware[category][vessel] ;
__p += '\n					<img class = "' +
((__t = (styles.stockroomIcon)) == null ? '' : __t) +
'" src = ' +
((__t = ( domain + glass.icon )) == null ? '' : __t) +
'>\n					<span class = "stockroomLabel">\n						<div class = "labelName">\n							<!--' +
((__t = ( glass.name.replace(/_/g, ' ') )) == null ? '' : __t) +
'-->\n                            ' +
((__t = (terms[glass.name][language])) == null ? '' : __t) +
'\n						</div>\n						<div class = "labelName">\n							' +
((__t = ( glass.maxVolume+" L")) == null ? '' : __t) +
'\n						</div>\n					</span>\n					<span class = "addButton btn glyphicon glyphicon-plus">\n					</span>\n				</div>\n			';
 } ;
__p += '\n		';
 } else { ;
__p += '\n		';
console.log("not stand alone"); ;
__p += '\n		<div id = ' +
((__t = ( i )) == null ? '' : __t) +
' class = "branch collapsed">\n			<span class="glyphicon glyphicon-chevron-right"></span>\n			<span class = "groupLabel">\n                    ' +
((__t = (terms[category][language])) == null ? '' : __t) +
'\n					<!--' +
((__t = ( category.replace(/_/g, ' ') )) == null ? '' : __t) +
'-->\n					<span class = "glasswareCount">\n                        ';
var count = 0;;
__p += '\n						';
for (vessel in glassware[category]) {;
__p += '\n                            ';
count++;;
__p += '\n                        ';
};
__p += '\n                        (' +
((__t = (count)) == null ? '' : __t) +
')\n					</span>\n			</span>\n		</div>\n		<div id = ' +
((__t = ( "branchContent"+i )) == null ? '' : __t) +
' style = "display:none;">\n			';
 for (vessel in  glassware[category]){ ;
__p += '\n				<div class = "glasswarePreview addGlassware" id = ' +
((__t = ( category+","+vessel )) == null ? '' : __t) +
' style = "cursor:pointer">\n					';
 var glass = glassware[category][vessel] ;
__p += '\n					<img class = "' +
((__t = (styles.stockroomIcon)) == null ? '' : __t) +
'" src = ' +
((__t = ( domain + glass.icon )) == null ? '' : __t) +
'>\n					<span class = "stockroomLabel">\n						<div class = "labelName">\n							<!--' +
((__t = ( glass.name.replace(/_/g, ' ') )) == null ? '' : __t) +
'-->\n                            ' +
((__t = (terms[glass.name][language])) == null ? '' : __t) +
'\n						</div>\n						<div class = "labelName">\n							' +
((__t = ( glass.maxVolume+" L" )) == null ? '' : __t) +
'\n						</div>\n					</span>\n					<span class = "addButton btn glyphicon glyphicon-plus">\n					</span>\n				</div>\n			';
 } ;
__p += '\n		</div>\n	';
 } ;
__p += '\n	';
 } ;
__p += '\n\n';
 }else if(drawer === "tools"){ ;
__p += '\n		';
 for (j in tools){ ;
__p += '\n		  	';
 var toolIndex = j ;
__p += '\n		  	';
 var tool = tools[toolIndex] ;
__p += '\n			<div class = "toolPreview addTool" id = ' +
((__t = ( toolIndex )) == null ? '' : __t) +
' style = "cursor:pointer">\n				<img class = "' +
((__t = (styles.stockroomIcon)) == null ? '' : __t) +
'" src = ' +
((__t = ( domain + tool.icon )) == null ? '' : __t) +
'>\n				<span class = "stockroomLabel">\n					<div class = "labelName">\n                        ' +
((__t = (terms[tool.name][language])) == null ? '' : __t) +
'\n						<!--' +
((__t = ( tool.name.replace(/_/g, ' ') )) == null ? '' : __t) +
'-->\n					</div>\n					<div class = "labelDescription">\n						' +
((__t = ( tool.description )) == null ? '' : __t) +
'\n					</div>\n				</span>\n				<span class = "addButton btn glyphicon glyphicon-plus">\n				</span>\n			</div>\n		';
 } ;
__p += '\n';
 } ;
__p += '\n</div>';

}
return __p
}